package com.example.mystybag.login.views


import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import androidx.compose.ui.Modifier
import com.example.mystybag.core.helpers.WebLocaleComposition
import com.arkivanov.decompose.extensions.compose.stack.Children
import com.arkivanov.decompose.extensions.compose.stack.animation.slide
import com.arkivanov.decompose.extensions.compose.stack.animation.stackAnimation
import com.example.mystybag.core.logic.base.BaseViewModel
import com.example.mystybag.core.logic.base.ParentViewModel
import com.example.mystybag.common.logic.InternetTroubleshootingViewModel
import com.example.mystybag.common.views.CommonViews
import com.example.mystybag.common.views.InternetTroubleshootingView
import com.example.mystybag.cropImage.logic.ProfileImageCropperViewModel
import com.example.mystybag.cropImage.views.ProfileImageCropperView
import com.example.mystybag.login.logic.EnterEmailViewModel
import com.example.mystybag.login.logic.ChooseCityViewModel
import com.example.mystybag.login.logic.VerifyEmailAddressViewModel
import com.example.mystybag.login.logic.WelcomeViewModel
import com.example.mystybag.login.logic.MerchantRegistrationAddLoginDetailsViewModel
import com.example.mystybag.login.logic.MerchantRegistrationCheckInboxViewModel
import com.example.mystybag.login.logic.MerchantRegistrationSuccessViewModel
import com.example.mystybag.login.logic.MerchantRegistrationUnderReviewViewModel
import com.example.mystybag.login.logic.AddLocationPromptViewModel
import com.example.mystybag.login.logic.AddFirstBagPromptViewModel
import com.example.mystybag.login.logic.MerchantRegistrationAddCompanyDetailsViewModel
import com.example.mystybag.login.logic.MerchantRegistrationAddCompanyContactViewModel
import com.example.mystybag.login.logic.MerchantRegistrationAddCompanyAddressViewModel
import com.example.mystybag.login.logic.AddMolViewModel
import com.example.mystybag.login.logic.MerchantRegistrationPaymentDataViewModel
import com.example.mystybag.login.views.views.MerchantRegistrationAddCompanyDetailsView
import com.example.mystybag.login.views.views.MerchantRegistrationAddCompanyContactView
import com.example.mystybag.login.views.views.MerchantRegistrationAddCompanyAddressView
import com.example.mystybag.login.views.views.AddMolView
import com.example.mystybag.login.logic.MerchantLoginViewModel
import com.example.mystybag.login.logic.MerchantBiometricViewModel
import com.example.mystybag.login.logic.MerchantForgotPasswordEmailViewModel
import com.example.mystybag.login.logic.MerchantResetPasswordViewModel
import com.example.mystybag.login.logic.StaffLoginViewModel
import com.example.mystybag.login.logic.StaffBiometricViewModel
import com.example.mystybag.login.logic.StaffForgotPasswordEmailViewModel
import com.example.mystybag.login.logic.StaffResetPasswordViewModel
import com.example.mystybag.login.logic.StaffChangePasswordViewModel
import com.example.mystybag.url.logic.URLViewViewModel
import com.example.mystybag.url.views.URLView
import com.example.mystybag.core.expected.PlatformHelper

@Composable
fun FeatureViewLoginAndRegistration(model: ParentViewModel, modifier: Modifier = Modifier) {
    Children(
        stack       = model.childStack,
        animation   = stackAnimation(slide()),
        modifier    = modifier.fillMaxSize()
    ) {
        val viewModel = it.instance
        if (viewModel is WelcomeViewModel) {
            if (PlatformHelper.isWeb) {
                val webLocaleKey = WebLocaleComposition.revision
                key(webLocaleKey) {
                    WelcomeView(viewModel)
                }
            } else {
                WelcomeView(viewModel)
            }
        } else if (PlatformHelper.isWeb && viewModel.isWebFullWidthLoginRegistrationChild()) {
            val webLocaleKey = WebLocaleComposition.revision
            key(webLocaleKey) {
                Box(modifier = Modifier.fillMaxSize()) {
                    LoginAndRegistrationChildView(viewModel)
                }
            }
        } else {
            AuthDesktopScreen {
                Box(modifier = Modifier.authScreenContentWidth()) {
                    LoginAndRegistrationChildView(viewModel)
                }
            }
        }
    }
}

@Composable
private fun LoginAndRegistrationChildView(viewModel: BaseViewModel) {
    when (viewModel) {
        is InternetTroubleshootingViewModel -> InternetTroubleshootingView(viewModel)
        is URLViewViewModel                 -> URLView(viewModel)
        is ChooseCityViewModel              -> ChooseCityView(viewModel)
        is VerifyEmailAddressViewModel      -> VerifyEmailAddressView(viewModel)
        is EnterEmailViewModel              -> EnterEmailView(viewModel)
        is MerchantRegistrationAddLoginDetailsViewModel -> MerchantRegistrationAddLoginDetailsView(viewModel)
        is MerchantRegistrationCheckInboxViewModel -> MerchantRegistrationCheckInboxView(viewModel)
        is MerchantRegistrationSuccessViewModel -> MerchantRegistrationSuccessView(viewModel)
        is MerchantRegistrationUnderReviewViewModel -> MerchantRegistrationUnderReviewView(viewModel)
        is AddLocationPromptViewModel -> AddLocationPromptView(viewModel)
        is AddFirstBagPromptViewModel -> AddFirstBagPromptView(viewModel)
        is MerchantRegistrationAddCompanyDetailsViewModel -> MerchantRegistrationAddCompanyDetailsView(viewModel)
        is MerchantRegistrationAddCompanyContactViewModel -> MerchantRegistrationAddCompanyContactView(viewModel)
        is MerchantRegistrationAddCompanyAddressViewModel -> MerchantRegistrationAddCompanyAddressView(viewModel)
        is AddMolViewModel -> AddMolView(viewModel)
        is MerchantRegistrationPaymentDataViewModel -> MerchantRegistrationPaymentDataView(viewModel)
        is MerchantLoginViewModel -> MerchantLoginView(viewModel)
        is MerchantBiometricViewModel -> MerchantBiometricView(viewModel)
        is MerchantForgotPasswordEmailViewModel -> MerchantForgotPasswordEmailView(viewModel)
        is MerchantResetPasswordViewModel -> MerchantResetPasswordView(viewModel)
        is StaffLoginViewModel -> StaffLoginView(viewModel)
        is StaffBiometricViewModel -> StaffBiometricView(viewModel)
        is StaffForgotPasswordEmailViewModel -> StaffForgotPasswordEmailView(viewModel)
        is StaffResetPasswordViewModel -> StaffResetPasswordView(viewModel)
        is StaffChangePasswordViewModel -> StaffChangePasswordView(viewModel)
        is ProfileImageCropperViewModel    -> ProfileImageCropperView(viewModel)
        else                                -> CommonViews(viewModel)
    }
}

/** Web: no `AuthDesktopScreen` split (gray left column); full-bleed like merchant login web. */
private fun BaseViewModel.isWebFullWidthLoginRegistrationChild(): Boolean = when (this) {
    is MerchantLoginViewModel,
    is EnterEmailViewModel,
    is VerifyEmailAddressViewModel,
    is ChooseCityViewModel,
    is MerchantRegistrationAddCompanyDetailsViewModel,
    is MerchantRegistrationAddCompanyContactViewModel,
    is MerchantRegistrationAddCompanyAddressViewModel,
    is MerchantRegistrationAddLoginDetailsViewModel,
    is MerchantRegistrationPaymentDataViewModel,
    is MerchantRegistrationCheckInboxViewModel,
    is MerchantRegistrationSuccessViewModel,
    is MerchantRegistrationUnderReviewViewModel,
    is AddMolViewModel,
    is AddLocationPromptViewModel,
    is AddFirstBagPromptViewModel,
    is MerchantForgotPasswordEmailViewModel,
    is MerchantResetPasswordViewModel,
    is StaffLoginViewModel,
    is StaffChangePasswordViewModel -> true
    else -> false
}

